// extracted by mini-css-extract-plugin
export default {"joke":"Joke_joke__4VR3Y"};